// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"519":"f8bbb43e","787":"9da980fc","812":"1eaa2eb5","994":"de46aef0"}[chunkId] + ".chunk.js";
};